import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const bounceDelay = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1.0);
  }
`;

const Spinner = styled.div`
  width: ${props => (props.size || 4) * 5}px;
  height: ${props => props.size || 29}px;
  padding-bottom: 8px;
  text-align: center;
  box-sizing: border-box;
  > div {
    margin-top: -16px;
    margin-right: 1px;
    width: ${props => props.size || 4}px;
    height: ${props => props.size || 4}px;
    background-color: ${props => (props.color ? props.color : props.theme.darkBlue)};
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: ${bounceDelay} 1.4s infinite ease-in-out both;
    animation: ${bounceDelay} 1.4s infinite ease-in-out both;
  }
`;

const Bounce1 = styled.div`
  -webkit-animation-delay: -0.32s !important;
  animation-delay: -0.32s !important;
`;

const Bounce2 = styled.div`
  -webkit-animation-delay: -0.16s !important;
  animation-delay: -0.16s !important;
`;


const LineLoader = (props) => {
  const { color, size, className } = props;
  return (
    <Spinner color={color} size={size} className={className}>
      <Bounce1 />
      <Bounce2 />
      <div/>
    </Spinner>
  );
};

LineLoader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};

export default LineLoader;
